import { render, staticRenderFns } from "./TerminalEnd.vue?vue&type=template&id=28d0ca2c&scoped=true&"
import script from "./TerminalEnd.vue?vue&type=script&lang=js&"
export * from "./TerminalEnd.vue?vue&type=script&lang=js&"
import style0 from "./TerminalEnd.vue?vue&type=style&index=0&id=28d0ca2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0ca2c",
  null
  
)

export default component.exports